import { processEvent } from '../core/processEvent'
import { type ClickLineSubscriptionEvent } from '../types/wordpress-line-subscription-events'

export const lineSubscriptionEvent = () => {
  const sendClickLineSubscriptionEvent = (eventParams?: ClickLineSubscriptionEvent['eventParams']) => {
    processEvent({
      event: {
        eventName: 'click_line_subscription',
        eventParams: eventParams ?? {},
      },
    })
  }

  return {
    sendClickLineSubscriptionEvent,
  }
}
